import React, { Component } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import Retouren from "./components/retouren";
import RetourenLijst from "./components/retouren/RetourenLijst";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";

class retouren extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "1",
    };
    this.renderView = this.renderView.bind(this);
    this.renderThumb = this.renderThumb.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    this.props.addBreadcrumb([
      { name: "Retouren", url: "/retouren", reset: true },
    ]);
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  renderView({ style, ...props }) {
    const viewStyle = {};
    return (
      <div className="box" style={{ ...style, ...viewStyle }} {...props} />
    );
  }

  renderThumb({ style, ...props }) {
    const thumbStyle = { borderRadius: "50px", backgroundColor: "#AEAEAE" };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
  }

  render() {
    return (
      <Scrollbars
        renderView={this.renderView}
        renderThumbHorizontal={this.renderThumb}
        renderThumbVertical={this.renderThumb}
        className="row ml-0 content-bc"
      >
        <div className="col p-md-4 px-0">
          <div className="p-lg-2 row">
            <div className="col mr-lg-3">
              {/*
              <Nav tabs className="mb-4">
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: this.state.activeTab === "1",
                    })}
                    onClick={() => {
                      this.toggle("1");
                    }}>
                    Retouren Lijst
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: this.state.activeTab === "2",
                    })}
                    onClick={() => {
                      this.toggle("2");
                    }}>
                    Retouren formulier
                  </NavLink>
                </NavItem>
              </Nav>
              */}
              <TabContent
                activeTab={this.state.activeTab}
                className="content-block text-left p-lg-3"
              >
                <TabPane tabId="1">
                  <div className="mb-4">
                    <RetourenLijst
                      addBreadcrumb={this.props.addBreadcrumb}
                      loading={this.props.loading}
                      onTabChange={this.toggle}
                      activeTab={this.state.activeTab}
                    />
                  </div>
                </TabPane>
                <TabPane tabId="2">
                  <div className="mb-4">
                    <Retouren
                      addBreadcrumb={this.props.addBreadcrumb}
                      loading={this.props.loading}
                      onTabChange={this.toggle}
                    />
                  </div>
                </TabPane>
              </TabContent>
            </div>
          </div>
        </div>
      </Scrollbars>
    );
  }
}

export default retouren;
